export const endpoints = {
  outlet: {
    submit: "/scb-laundry/MNU_OUTLET/submit",
    delete: "/scb-laundry/MNU_OUTLET/submitDelete",
    getCity: "/scb-laundry/MNU_OUTLET/getCity",
    search: "/scb-laundry/MNU_OUTLET/search",
  },
  machine: {
    submit: "/scb-laundry/MNU_MACHINE/submit",
    delete: "/scb-laundry/MNU_MACHINE/submitDelete",
    getMachineType: "/scb-laundry/MNU_MACHINE/getMachineType",
    getOutlet: "/scb-laundry/MNU_MACHINE/getOutlet",
    search: "/scb-laundry/MNU_MACHINE/search",
  },
};
